import React, { useState, useEffect } from 'react';
import { C } from '../theme';
import { Card, CardTitle, QuoteBox } from '../components/Card';
import { calcRoot, getDecisionAdvice } from '../utils/data';

const MONTH_NAMES = ['يناير','فبراير','مارس','أبريل','مايو','يونيو','يوليو','أغسطس','سبتمبر','أكتوبر','نوفمبر','ديسمبر'];
const DAY_NAMES = ['أح','اث','ث','أر','خ','ج','س'];
const DAY_COLORS = {
  1:'rgba(212,168,71,.15)',2:'rgba(91,127,212,.12)',3:'rgba(74,165,120,.12)',
  4:'rgba(165,140,74,.12)',5:'rgba(212,100,100,.12)',6:'rgba(180,100,212,.12)',
  7:'rgba(91,180,212,.12)',8:'rgba(212,168,71,.2)',9:'rgba(165,74,74,.12)',
};

export default function CalendarScreen() {
  const [selectedDay, setSelectedDay] = useState(null);
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const firstDay = new Date(year, month, 1).getDay();
  const startOffset = (firstDay + 1) % 7;
  const todayRoot = calcRoot(now.getDate(), month + 1, year);

  const cells = [];
  for (let i = 0; i < startOffset; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  return (
    <div>
      <QuoteBox text="كل يوم يحمل رقماً، وكل رقم يحمل نبضاً، فمن يعرف نبض يومه يمشي في الزمن بلا عثرة" src="جذر الفلك، الجزء الثالث" />
      <Card>
        <CardTitle>📅 التقويم الرقمي الشهري</CardTitle>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
          <span style={{fontSize:11,color:C.text2}}>اضغط على أي يوم للتفاصيل</span>
          <span style={{fontSize:14,color:C.text}}>{MONTH_NAMES[month]} {year}</span>
        </div>

        {/* Day headers */}
        <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',gap:4,marginBottom:4}}>
          {DAY_NAMES.map(d=><div key={d} style={{textAlign:'center',fontSize:10,color:C.text2,padding:'4px 0',fontWeight:600}}>{d}</div>)}
        </div>

        {/* Calendar grid */}
        <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',gap:4,marginBottom:16}}>
          {cells.map((day, i) => {
            if (!day) return <div key={`e${i}`} />;
            const root = calcRoot(day, month + 1, year);
            const isToday = day === now.getDate();
            const isSel = selectedDay === day;
            return (
              <div key={day}
                onClick={() => setSelectedDay(isSel ? null : day)}
                style={{
                  aspectRatio: '1', borderRadius: 8, display: 'flex', flexDirection: 'column',
                  alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
                  background: DAY_COLORS[root] || 'transparent',
                  border: isToday ? `1px solid ${C.gold}` : isSel ? `1px solid ${C.accent}` : '1px solid transparent',
                  boxShadow: isToday ? '0 0 8px rgba(212,168,71,.3)' : 'none',
                  transition: 'all .2s',
                }}>
                <span style={{fontSize:11,color:C.text,fontWeight:600}}>{day}</span>
                <span style={{fontSize:9,color:C.gold,fontWeight:700}}>{root}</span>
              </div>
            );
          })}
        </div>

        {/* Today detail */}
        <div style={{background:C.bg3,border:`1px solid ${C.goldDim}`,borderRadius:12,padding:'14px 16px',marginBottom:selectedDay?12:0}}>
          <div style={{fontFamily:'Amiri,serif',fontSize:14,color:C.gold,marginBottom:6}}>✦ اليوم ({now.getDate()} {MONTH_NAMES[month]})</div>
          <div style={{fontSize:13,marginBottom:4}}>رقم اليوم: <strong style={{color:C.gold,fontSize:20,fontFamily:'Amiri,serif'}}>{todayRoot}</strong></div>
          <div style={{fontSize:13,color:C.text2}}>{getDecisionAdvice(todayRoot)}</div>
        </div>

        {/* Selected day detail */}
        {selectedDay && selectedDay !== now.getDate() && (
          <div style={{background:C.bg3,border:`1px solid ${C.border}`,borderRadius:10,padding:'12px 14px',animation:'fadeUp .3s ease'}}>
            <div style={{fontSize:13,color:C.gold,marginBottom:5}}>{selectedDay} {MONTH_NAMES[month]} — رقم {calcRoot(selectedDay, month+1, year)}</div>
            <div style={{fontSize:13,color:C.text2}}>{getDecisionAdvice(calcRoot(selectedDay, month+1, year))}</div>
          </div>
        )}
      </Card>
    </div>
  );
}
